module.exports = __webpack_public_path__ + "img/device-like.02752b7d.svg";